import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { RestService } from './rest.service';

@Injectable({
	providedIn: 'root'
})
export class JobsSearchMetaService extends RestService {
	public url = environment.api + '/jobs/search-meta';
}
